import { render, staticRenderFns } from "./QuickLinkItem.vue?vue&type=template&id=9ee1673a&"
import script from "./QuickLinkItem.vue?vue&type=script&lang=js&"
export * from "./QuickLinkItem.vue?vue&type=script&lang=js&"
import style0 from "./QuickLinkItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports